import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Input,
    Label,
    FormFeedback
} from "reactstrap";

//redux
import { useDispatch } from "react-redux";

//api
import { apiCaller } from "@utils";
import { agreementsConstants } from "@constants";

const ModalAddChatTopic = (props) => {
    const { isOpen, toggle, ParentChatTopicId, rowData } = props && props;
    const dispatch = useDispatch();

    //state
    const [isLoading, setLoading] = useState(false);

    //form
    const {
        register,
        formState: { errors },
        handleSubmit,
        watch,
        setValue
    } = useForm();

    const onSubmit = (data) => {
        setLoading(true);
        const isLoading = true;
        const params = {
            "Action": "AddStandardChatTopicProperty",
            "ParentChatTopicId": ParentChatTopicId,
            "Name": data?.Name,
            "StandardResponse": data?.StandardResponse,
            "Type": "symptom"
        }

        //Call Api
        dispatch({ type: agreementsConstants.ADD_STANDARD_CHAT_TOPICS_REQUEST, isLoading });
        apiCaller(`/api/teach/chat/standard/`, "POST", params).then((res) => {
            const data = res && res.data;
            if (res && res.status === 200) {
                dispatch({
                    type: agreementsConstants.ADD_STANDARD_CHAT_TOPICS_SUCCESS,
                    payload: data,
                    isActive: rowData?.SectionName,
                    ParentChatTopicId: ParentChatTopicId || ''
                });

                //Close
                toggle();
                setLoading(false);

                //Reset data
                setValue('Name', '', { shouldValidate: false });
            } else {
                dispatch({ type: agreementsConstants.ADD_STANDARD_CHAT_TOPICS_FAILURE, error: 'error' });
                setLoading(false);
            }
        });
    }

    return (
        <div>
            <Modal isOpen={isOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>Add Property</ModalHeader>
                <ModalBody>
                    <FormGroup className="mt-2">
                        <Label for="Name">Name <span className="m--font-danger">*</span></Label>
                        <Input
                            type="text"
                            name="Name"
                            {...register("Name", { required: true })}
                            invalid={errors.Name?.type === "required"}
                            defaultValue={watch("Name")}
                            onChange={(e) => {
                                setValue("Name", e.target.value, { shouldValidate: true });
                            }}
                            placeholder=""
                            autoComplete="off"
                        />
                        <FormFeedback invalid={String(errors.Name?.type === "required")}>
                            This is required.
                        </FormFeedback>
                    </FormGroup>
                    <FormGroup className="mt-2">
                        <Label htmlFor="StandardResponse">StandardResponse:</Label>
                        <Input
                            type="textarea"
                            name="StandardResponse"
                            onChange={(e) => {
                                setValue("StandardResponse", e.target.value, { shouldValidate: true });
                            }}
                            defaultValue={watch("StandardResponse")}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>{" "}
                    <Button
                        color="primary"
                        className="d-flex align-items-center"
                        onClick={handleSubmit(onSubmit)}
                        disabled={isLoading}
                    >
                        {isLoading && <span className="spinner-border spinner-border-sm mr-2"></span>}
                        Add
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ModalAddChatTopic;